import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import OnboardingGate from "@/components/OnboardingGate";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="font-sans uppercase tracking-[0.28em] text-xs text-bone-400" data-testid="auth-checking">
          Opening the workbook…
        </p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/" replace />;
  }
  // Wrap protected routes in the T&C + age gate. Non-blocking on API failure.
  return <OnboardingGate>{children}</OnboardingGate>;
}
